import { Badge, Button, TextStyle } from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const StatusCell = (props) => {
  const { cell } = props;

  const { original: alert } = cell?.row;

  const { actions, meta = {} } = cell.column;

  const resolveAlert = () => {
    actions.onClick(alert);
  };

  return (
    <div className="flex-row flex-align-center">
      <Badge status={cell?.value === 'Open' ? 'info' : 'success'}>
        {cell.value}
      </Badge>
      {cell?.value === 'Open' && !meta.noAction ? (
        <div className="ml-30 visibility-hidden edit-actions">
          <Button
            id="alertManagementResolve"
            secondary
            onClick={resolveAlert}
            icon={<SVGIcon name="Resolution" />}
          >
            <div className="flex-row flex-align-center" data-id="resolve">
              <TextStyle weight="Medium">
                <FormattedMessage id="asset.alertViews.resolvebtn" />
              </TextStyle>
            </div>
          </Button>
        </div>
      ) : (
        <span />
      )}
    </div>
  );
};

export default StatusCell;
